var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page title-page"},[_c('square',{attrs:{"src":_vm.image,"height":_vm.book.type,"radius":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }